// extracted by mini-css-extract-plugin
export default {"content":"AppointmentPatientSelectPage_content__FLOrs"};